import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { faAngleLeft, faCheckCircle, faFolderOpen, faAngleDown, faDownload, faFileExport, faPowerOff, faShareAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { EventEmitter } from '@angular/core';
import { ConfirmationdialogueService } from '../confirmationdialogue/confirmationdialogue.service';
import { ToastrService } from 'ngx-toastr';
import { isNullOrEmpty } from '../helper/validation';
import { SharedService } from '../helper/shared/shared.service';
import { ProjectService } from '../project/project.service';
import { UserInfoService } from '../user-info/user-info.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { createPopper } from '@popperjs/core';  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  @ViewChild('templateShare', { static: false }) shareModal: any;

  @Input() Message: string = "";
  @Input() Action: string = "Save";
  @Input() ConfirmHead: string = "";
  @Input() Confirmbody: string = "";
  @Input() Visible: boolean = false;
  @Input() path: string = "";
  @Output() exposeChild: EventEmitter<String> = new EventEmitter<String>();
  @Input() VisibleSaveClass: boolean = false;

  pathString;
  faAngleLeft = faAngleLeft;
  faCheckCircle = faCheckCircle;
  editMode = false;
  faFolderOpen = faFolderOpen;
  faAngleDown = faAngleDown;
  faDownload = faDownload;
  faFileExport = faFileExport;
  faPowerOff = faPowerOff;
  faShareAlt = faShareAlt;
  faInfoCircle = faInfoCircle;  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)
  clickedOptionsBtn = false;

  pExportType = "Incomplete"; //Incomplete / Complete
  ProjectID: any = [];
  loading = true;
  link: any;
  team: any;
  emailTeam: any = [];
  sharedProjectName = "";
  closeResult: string;
  shareOrExportOnly: string;
  exportResultData: any;
  copyInfo: any; //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)
  sendInfo: any; //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)

  constructor(
    private confirmationDialogService: ConfirmationdialogueService,
    private toastr: ToastrService,
    public sharedService: SharedService,
    public projectService: ProjectService,
    private userInfoService: UserInfoService,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router
  ) { }

  ngOnInit(): void {
    //Pinky : unable to load project due to no details in projectService. this.Message = this.projectService.projectdetails.projectInfo.name;  //Modified by JW(2022-10-07): new project name does not reflect to header project
    // if (this.projectService != undefined) {
    //   if (this.projectService.projectdetails.projectInfo != undefined) {
    //     this.Message = this.projectService.projectdetails.projectInfo.name;
    //   }
    // }

    this.initializeTeam(false);
    this.Message = this.sharedService.headerProjectName;

    //Modified by PP(2023-02-28) : If click on new project then go back to Home -> Program settings, title becomes Untitled Project - START
    // if (this.sharedService.FromProgramSettings) {
    //   this.Message = "Program Settings";
    // }

    if (this.sharedService.FromProgramSettings === true) {
      this.Message = "Program Settings";
    } else if (this.sharedService.UserInfoMode === true) {
      this.Message = "User Information";

    } else {
      if (this.sharedService.blnLoadFromRecord === false) {
        if (this.projectService.projectdetails.projectInfo != undefined) {
          this.Message = this.projectService.projectdetails.projectInfo.projectName;
        }
      }
    }


    //Modified by PP(2023-02-28) : If click on new project then go back to Home -> Program settings, title becomes Untitled Project - END

    //Modified by PP(2023-03-27) : Folder Path - START
    if (this.route.snapshot.url[0].path == 'project' || this.route.snapshot.url[0].path == 'projectedit' || this.route.snapshot.url[0].path == 'importxml') {
      this.pathString = this.path.split("/");
      this.pathString.pop();
      for (var i = 0; i < this.pathString.length; i++) {
        if (this.pathString[i] == 'undefined') {
          this.pathString.splice(i, 1);
        }
      }
      this.projectService.projectdetails.NewPath = '';
    }
    //Modified by PP(2023-03-27) : Folder Path - END
  }

  ngAfterContentInit() {
    var abc = 123;
  }

  ngAfterViewInit() {
    //Modified by PP(2023-03-27) : Folder Path - START
    if (this.projectService.projectdetails.NewPath == undefined) {
      this.projectService.projectdetails.NewPath = '';
    }
    //Modified by PP(2023-03-27) : Folder Path - END
  }

  toggleEdit() {
    //this.sharedService.projectEditName = this.Message;   //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
    this.sharedService.headerProjectName = this.Message;   //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
    if (!this.editMode) {
      this.editMode = true;
    }
    else {
      this.editMode = false;
      //this.projectService.projectdetails.projectInfo.projectName = this.Message;  //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
    }
  }

  addRow() {
    if (this.team.length < 10) {
      let team = {
        "Name": "",
        "Email": ""
      }
      this.team.push(team);
    }
  }

  sendEmail() {
    var fail = false;
    this.emailTeam = [];
    var noEmail = 0;
    this.loading = true;

    if (this.team.length == 0) {
      fail = true;
      this.toastr.warning('Unable to send Email Out. Team Members must not be empty', '');
    }

    for (var x = 0; x < this.team.length; x++) {
      if (this.team[x].Email == "" && this.team[x].Name == "") {
        noEmail = noEmail + 1;
      }
    }
    if (noEmail == this.team.length) {
      fail = true;
      this.toastr.warning('Unable to send Email Out. Team Members must not be empty', '');
    }

    if (!fail) {
      for (var x = 0; x < this.team.length; x++) {
        if (this.team[x].Email == "" && this.team[x].Name != "") {
          fail = true;
          this.toastr.warning('Email Cannot Be Blank.', '');
          break;
        }

        if (!fail) {
          if (this.team[x].Name == "" && this.team[x].Email != "") {
            fail = true;
            this.toastr.warning('Name Cannot Be Blank.', '');
            break;
          }
        }
      }
    }

    if (!fail) {
      for (var x = 0; x < this.team.length; x++) {
        if (this.team[x].Email != "" && this.team[x].Name != "") {
          let tmpTeam = {
            "Name": this.team[x].Name,
            "Email": this.team[x].Email
          }
          this.emailTeam.push(tmpTeam);
        }
      }
      this.triggerPrepareSendEmail();
    }
  }

  initializeTeam(needToClose) {
    this.team = [{
      "Name": "",
      "Email": ""
    },
    {
      "Name": "",
      "Email": ""
    },
    {
      "Name": "",
      "Email": ""
    }
    ];

    if (needToClose) {
      this.modalService.dismissAll();
    }
  }

  copyLink(link) {
    link.select();
    document.execCommand('copy');
    this.toastr.success('Link has been copied', '');
  }

  //pplim
  copyLink2(s: string) {
    navigator.clipboard.writeText(s).then(() => {
      this.toastr.success('Link copied successfully', '');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  triggerPrepareSendEmail() {
    var Data: any = {};
    Data.EmailTeam = this.emailTeam;
    this.sharedService.CountTotalSeqForUploadingParams(Data, "UPLOAD MCCLD PARAMS TO SERVER");
    this.PrepareToUploadParams(true);
  }

  prepareExportToXML(pType) {
    this.shareOrExportOnly = pType;
    if (this.projectService.projectdetails.projectInfo != undefined) {
      this.projectService.projectdetails.projectInfo.projectName = this.Message;
    }

    this.addRemoveZIndex('add');
    this.ProjectID = [];
    this.pExportType = "Incomplete";

    if (this.projectService.projectdetails.results != undefined) {
      if (this.projectService.projectdetails.results.solutionsResults.length > 0) {
        if (this.projectService.projectdetails.results.solutionsResults[0].astmResults.combinationID > 0) {
          this.pExportType = "Calculated";
          this.ProjectID.push(this.projectService.projectdetails.projectInfo.id);
        } else {
          if (this.projectService.projectdetails.results.solutionsResults[0].results[0].combinationID > 0) {
            this.pExportType = "Calculated";
            this.ProjectID.push(this.projectService.projectdetails.projectInfo.id);
          }
        }
      }
    }

    if (this.ProjectID.length == 0) {
      this.ProjectID.push(0);
    }

    this.triggerCalculation();
  }

  triggerCalculation() {
    this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0);
    this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
    this.PrepareToUploadParams(false);
  }

  PrepareToUploadParams(forEmail) {
    //temp.push({0:0});
    var dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(
      res => {
        console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
        if (res) {
          this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
          this.sharedService.ServerDataReady = true;
          this.sharedService.UploadingEntry = false;
          if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
            this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
            this.PrepareToUploadParams(forEmail);
          } else {
            if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
              if (forEmail) {
                this.projectService.emailURL(this.emailTeam, this.link, this.sharedProjectName).subscribe(emailed => {  //Modified by PP(2020-10-07): LCC3 Bugs
                  if (emailed) {

                    this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'EMAILPROJECT').subscribe(result => {                       
                      if (result) {}
                    });


                    this.loading = false;
                    this.toastr.success('Email has been sent', '');
                    this.modalService.dismissAll();
                  } else {
                    this.loading = false;
                    this.toastr.warning('Something went wrong when emailing of URL', '');
                  }
                });
              } else {
                this.projectService.exportToXML(this.ProjectID, this.pExportType).subscribe(async exportResultData => {
                  this.exportResultData = exportResultData;                  

                  if (this.shareOrExportOnly == "Export2XML") {

                    this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'EXPORTCALCULATION').subscribe(result => {                       
                      if (result) {}
                    });

                    this.toastr.success('The xml file has been exported', '');

                    //pplim 20250924: bloburl
                    //window.open(exportResultData.URL);
                    if (exportResultData && exportResultData.URL && exportResultData.ZipFileName) {
                      try {
                        const blob = await this.sharedService.downloadFile(exportResultData.URL);
                        const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', exportResultData.ZipFileName);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                      } catch (error) {
                        this.toastr.error('Error downloading report')
                        console.error('Error downloading report', error);
                      } finally {
                        this.toastr.success('MCCLD report : Successfully generate report.')
                      }
                    } else {
                      this.toastr.error('Failed to generate report.')
                    }

                  } else { //ShareProject
                    if (this.team == undefined) {

                    }
                    this.link = exportResultData.URL;
                    this.sharedProjectName = exportResultData.ProjectName;
                    this.loading = false;

                    this.modalService.open(this.shareModal, {
                      ariaLabelledBy: 'modal-basic-title',
                      centered: true,
                      size: 'lg', //pplim
                      backdrop: 'static',
                    }).result.then((result) => {

                    }, (reason) => {
                      this.closeResult = `Dismissed`;
                    });
                    this.toastr.success('The xml file has been exported', '');
                  }
                },
                  error => {
                    var abc = error;
                  },
                  () => {
                    var abc = 123;
                  }
                );
              }
            } else {
              if (forEmail) {
                this.loading = false;
                this.toastr.error('Failed to upload Parameters for Emailing. TotalPass <> TotalSeq.', '');
              } else {
                this.toastr.error('Failed to upload Parameters for XML Exporting. TotalPass <> TotalSeq.', '');
              }
            }
          }
        } else {
          this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
          this.sharedService.UploadingEntry = false;
          this.sharedService.ServerDataReady = false;
          this.toastr.error('Failed to upload Parameters for XML Exporting. TotalFail>1.', '');
        }
      },
      err => {
        this.toastr.error('Failed to upload Parameters.Please try again.', '');
      }
    );
  }

  submitORI(action) {
    this.sharedService.AutoSave = false;
    if (action === 'autosave') {
      this.sharedService.AutoSave = true;
    }

    var SaveProgramSettings = false;
    var SaveDB = false;
    if (this.Message == "Program Settings") { //For Save Program Settings
      SaveProgramSettings = true;
    } else { //For Save to DB
      SaveDB = true;
    }

    if (SaveProgramSettings && action === undefined) {
      this.confirmationDialogService
        .confirm(this.ConfirmHead, this.Confirmbody)
        .then((confirmed) => this.exposeChild.emit("send data from child to parent"))
        .catch(() => console.log('User dismissed the dialog'));
    }

    if (SaveDB) {
      this.CheckProjectExist(action);
    }
  }

  submit(action) {
    this.sharedService.AutoSave = false;
    var SaveProgramSettings = false;
    var UserInformation = false;
    var SaveDB = false;

    if (this.Message == "Program Settings") {
      SaveProgramSettings = true;
      // if (action === 'autosave') {

      // } else {
      //   SaveProgramSettings = true;
      // }

    } else if (this.Message == "User Information") {
      UserInformation = true;
    } else {
      //For Save to DB
      if (this.projectService.projectdetails.projectInfo != undefined) {
        //this.projectService.projectdetails.projectInfo.projectName = this.Message;      //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
        SaveDB = true;
      } else { //New Project
        if (this.Message != "Program Settings") {
          this.projectService.projectdetails.ProjectName = this.Message;
          SaveDB = true;
        } else if (this.Message == "Program Settings") { //Save Program Settings
          SaveProgramSettings = true;
        }
      }
    }

    if (SaveProgramSettings) {
      if (action === undefined) {
        this.confirmationDialogService
          .confirm(this.ConfirmHead, this.Confirmbody)
          .then((confirmed) => this.exposeChild.emit("send data from child to parent"))
          .catch(() => console.log('User dismissed the dialog'));
      } else if (action === 'autosave') {
        this.router.navigate(["home"]);
      }

    }

    if (UserInformation) {
      this.router.navigate(["home"]);
    }

    if (SaveDB) {
      this.CheckProjectExist(action);
    }

  }

  CheckProjectExist(action) { //not tested
    let ProjID = 0;
    let ProjName = "";
    if (this.projectService.projectdetails.projectInfo.id != undefined) {
      ProjID = this.projectService.projectdetails.projectInfo.id;
    } else {
      ProjID = 0;
    }

    if (this.projectService.projectdetails.projectInfo != undefined) {
      ProjName = this.projectService.projectdetails.projectInfo.projectName;
    } else {
    }
    this.projectService.CheckProjExist(ProjName, ProjID, this.sharedService.currentFolderID).subscribe(recExist => {
      if (recExist) {
        let msg = 'Project Already Exist. Overwrite?';
        let title = this.ConfirmHead;
        let btnOkText = 'Confirm';
        let btnCancelText = 'Cancel';
        if (action === 'autosave') {
          msg = 'Do you want to save your changes?';
          title = 'Exit project';
          btnOkText = 'Yes – I need to save it';
          btnCancelText = 'No - Exit project';
        }

        //this.confirmationDialogService.confirm( this.ConfirmHead, msg)
        this.confirmationDialogService.confirm(title, msg, btnOkText, btnCancelText)
          .then((confirmed) => this.exposeChild.emit("send data from child to parent")) //emmiting the event.)
          .catch(() => console.log('User dismissed the dialog'));
      } else {
        let msg = this.Confirmbody;
        let title = this.ConfirmHead;
        let btnOkText = 'Confirm';
        let btnCancelText = 'Cancel';

        if (action === 'autosave') {
          msg = 'Do you want to save your changes?';
          title = 'Exit project';
          btnOkText = 'Yes – I need to save it';
          btnCancelText = 'No - Exit project';
        }
        //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
        else {
          if (this.projectService.projectdetails.projectInfo.projectName !== this.Message) {
            this.sharedService.projectEditName = this.Message;
            msg = "Do You really want to replace the " + this.projectService.projectdetails.projectInfo.projectName + " with " + this.Message + "?";
          } else {
            msg = 'Do You really want to save the changes in "' + this.Message + '" ?';
          }
        }
        //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end

        //this.confirmationDialogService.confirm( this.ConfirmHead, this.Confirmbody)
        this.confirmationDialogService.confirm(title, msg, btnOkText, btnCancelText)
          .then((confirmed) => this.exposeChild.emit("send data from child to parent")) //emmiting the event.)
          .catch(() => console.log('User dismissed the dialog'));
      }
    });
  }

  addRemoveZIndex(WhichOption) {
    this.clickedOptionsBtn = true;
    var headerMenuClass: any;
    switch (WhichOption) {
      case 'add':
        headerMenuClass = document.getElementsByClassName('topbar');
        for (var i = 0; i < headerMenuClass.length; i++) {
          this.sharedService.clickOnMoreOptionsBtn = false;
          headerMenuClass[i].style.zIndex = '99';
        }
        break;

      case 'remove':
        headerMenuClass = document.getElementsByClassName('topbar');
        for (var i = 0; i < headerMenuClass.length; i++) {
          this.sharedService.clickOnMoreOptionsBtn = true;
          //headerMenuClass[i].style.zIndex = '-1';
          headerMenuClass[i].style.zIndex = 10;
        }
        break;
    }
  }

  validateSpecialChar(event: any) {
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (format.test(event.key)) {
      this.toastr.warning("Invalid character - you may not use certain characters here", "");
      return false;
    } else {
      return true;
    }
  }

  saveAS() {
    console.log('SaveAs');
    this.projectService.projectdetails.projectInfo.projectName = this.Message;

  }

  onMouseClick(e: MouseEvent) {
    if (!this.clickedOptionsBtn) {
      if (this.sharedService.clickOnMoreOptionsBtn) {
        var headerMenuClass: any;
        headerMenuClass = document.getElementsByClassName('topbar');
        for (var i = 0; i < headerMenuClass.length; i++) {
          if (headerMenuClass[i].style.zIndex == '-1') {
            headerMenuClass[i].style.zIndex = '99';
          } else {
            headerMenuClass[i].style.zIndex = '-1';
          }
        }
      }
    }

    //Modified by PP(2022-04-05) : To include Share and Export Project into More Options - START
    if (this.clickedOptionsBtn) {
      //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
      // if (this.projectService.projectdetails.projectInfo != undefined) {
      //   this.projectService.projectdetails.projectInfo.projectName = this.Message;
      // }
      this.sharedService.headerProjectName = this.Message;
      //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end
      this.clickedOptionsBtn = false;
    }
    //Modified by PP(2022-04-05) : To include Share and Export Project into More Options - END
  }

  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-start
  showHideInfoToggle(field: string) {
    switch (field) {
      case 'copy':
        let CopyInfo = document.getElementById('CopyInfoBtn');
        let CopyInfoToolTip = document.getElementById('CopyInfo');
        this.createPop(CopyInfo, CopyInfoToolTip);
        if (this.copyInfo) {
          CopyInfoToolTip.removeAttribute("data-show");
          this.copyInfo = false;
        } else {
          CopyInfoToolTip.setAttribute("data-show", "");
          this.copyInfo = true;
        }
        break;
      case 'send':
        let SendInfo = document.getElementById('SendInfoBtn');
        let SendInfoToolTip = document.getElementById('SendInfo');
        this.createPop(SendInfo, SendInfoToolTip);
        if (this.sendInfo) {
          SendInfoToolTip.removeAttribute("data-show");
          this.sendInfo = false;
        } else {
          SendInfoToolTip.setAttribute("data-show", "");
          this.sendInfo = true;
        }
        break;
    }
  }

  createPop(ref: any, popper: any) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
      ],
    });
  }
  //Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-end
}
